import React, { Component } from 'react';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

class AdminMessages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'conversations',
      conversations: [],
      convoLoading: true,
      convoPage: 1,
      convoPages: 1,
      convoTotal: 0,
      statusFilter: '',
      search: '',
      flaggedMessages: [],
      flaggedLoading: true,
      flaggedPage: 1,
      flaggedPages: 1,
      // Thread view
      selectedConvo: null,
      threadMessages: [],
      threadLoading: false,
      // Support inbox
      supportConversations: [],
      supportLoading: true,
      supportPage: 1,
      supportPages: 1,
      supportTotal: 0,
      supportSearch: '',
      supportStatusFilter: 'active',
      supportSelectedConvo: null,
      supportMessages: [],
      supportThreadLoading: false,
      replyText: '',
      replySending: false,
    };
    this.fetchConversations = this.fetchConversations.bind(this);
    this.fetchFlagged = this.fetchFlagged.bind(this);
    this.openThread = this.openThread.bind(this);
    this.closeThread = this.closeThread.bind(this);
    this.handleFlagMessage = this.handleFlagMessage.bind(this);
    this.handleCloseConversation = this.handleCloseConversation.bind(this);
    this.fetchSupportConversations = this.fetchSupportConversations.bind(this);
    this.openSupportThread = this.openSupportThread.bind(this);
    this.closeSupportThread = this.closeSupportThread.bind(this);
    this.handleSendReply = this.handleSendReply.bind(this);
    this.searchTimeout = null;
    this.supportSearchTimeout = null;
  }

  componentDidMount() {
    var self = this;
    this.fetchConversations();
    this.fetchFlagged();
    this.fetchSupportConversations();

    // Auto-open support thread if navigated from UserDetailModal
    if (this.props.location && this.props.location.state && this.props.location.state.supportConvoId) {
      var convoId = this.props.location.state.supportConvoId;
      self.setState({ tab: 'support' });
      self.openSupportThread(convoId);
      // Clear location state so refresh doesn't re-open
      this.props.history.replace('/admin/messages');
    }
  }

  fetchConversations(page) {
    var self = this;
    self.setState({ convoLoading: true });
    var p = page || self.state.convoPage;
    var params = new URLSearchParams();
    params.append('page', p);
    params.append('limit', 20);
    if (self.state.statusFilter) params.append('status', self.state.statusFilter);
    if (self.state.search) params.append('search', self.state.search);

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/messages?' + params.toString())
      .then(function(data) {
        self.setState({
          conversations: data.conversations || [],
          convoTotal: data.total || 0,
          convoPage: data.page || 1,
          convoPages: data.pages || 1,
          convoLoading: false,
        });
      })
      .catch(function(err) {
        console.log('Failed to fetch admin conversations:', err);
        self.setState({ convoLoading: false });
      });
  }

  fetchFlagged(page) {
    var self = this;
    self.setState({ flaggedLoading: true });
    var p = page || self.state.flaggedPage;
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/messages/flagged?page=' + p + '&limit=20')
      .then(function(data) {
        self.setState({
          flaggedMessages: data.messages || [],
          flaggedPage: data.page || 1,
          flaggedPages: data.pages || 1,
          flaggedLoading: false,
        });
      })
      .catch(function(err) {
        console.log('Failed to fetch flagged messages:', err);
        self.setState({ flaggedLoading: false });
      });
  }

  openThread(convoId) {
    var self = this;
    self.setState({ threadLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/messages/' + convoId)
      .then(function(data) {
        self.setState({
          selectedConvo: data.conversation,
          threadMessages: data.messages || [],
          threadLoading: false,
        });
      })
      .catch(function(err) {
        console.log('Failed to fetch thread:', err);
        self.setState({ threadLoading: false });
        alert('Failed to load conversation');
      });
  }

  closeThread() {
    this.setState({ selectedConvo: null, threadMessages: [] });
  }

  handleFlagMessage(messageId) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/messages/' + messageId + '/flag', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function() {
        // Update local state for both thread views
        var updater = function(m) {
          if (m._id === messageId) return Object.assign({}, m, { flagged: true, flaggedAt: new Date().toISOString() });
          return m;
        };
        self.setState(function(prev) {
          return {
            threadMessages: prev.threadMessages.map(updater),
            supportMessages: prev.supportMessages.map(updater),
          };
        });
        self.fetchFlagged();
      })
      .catch(function(err) { alert('Failed to flag message: ' + (err.message || 'Unknown error')); });
  }

  handleCloseConversation(convoId, reason) {
    var self = this;
    self.props.onConfirm({
      title: 'Close Conversation',
      message: 'Close this conversation? Users will no longer be able to send messages.',
      btnColor: '#6B7280',
      btnIcon: 'fa-times-circle',
      onConfirm: function() {
        return Auth.fetch(constants.DOMAIN + '/api/v1/admin/messages/' + convoId + '/close', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ reason: reason || 'Closed by admin' }),
        })
          .then(function() {
            self.fetchConversations();
            self.fetchSupportConversations();
            if (self.state.selectedConvo && self.state.selectedConvo._id === convoId) {
              self.setState(function(prev) {
                return { selectedConvo: Object.assign({}, prev.selectedConvo, { status: 'admin_closed' }) };
              });
            }
            if (self.state.supportSelectedConvo && self.state.supportSelectedConvo._id === convoId) {
              self.setState(function(prev) {
                return { supportSelectedConvo: Object.assign({}, prev.supportSelectedConvo, { status: 'admin_closed' }) };
              });
            }
          })
          .catch(function(err) { alert('Failed to close conversation: ' + (err.message || 'Unknown error')); });
      }
    });
  }

  fetchSupportConversations(page) {
    var self = this;
    self.setState({ supportLoading: true });
    var p = page || self.state.supportPage;
    var params = new URLSearchParams();
    params.append('page', p);
    params.append('limit', 20);
    if (self.state.supportSearch) params.append('search', self.state.supportSearch);
    if (self.state.supportStatusFilter) params.append('status', self.state.supportStatusFilter);

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/messages/support?' + params.toString())
      .then(function(data) {
        self.setState({
          supportConversations: data.conversations || [],
          supportTotal: data.total || 0,
          supportPage: data.page || 1,
          supportPages: data.pages || 1,
          supportLoading: false,
        });
      })
      .catch(function(err) {
        console.log('Failed to fetch support conversations:', err);
        self.setState({ supportLoading: false });
      });
  }

  openSupportThread(convoId) {
    var self = this;
    self.setState({ supportThreadLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/messages/' + convoId)
      .then(function(data) {
        self.setState({
          supportSelectedConvo: data.conversation,
          supportMessages: data.messages || [],
          supportThreadLoading: false,
        });
      })
      .catch(function(err) {
        console.log('Failed to fetch support thread:', err);
        self.setState({ supportThreadLoading: false });
        alert('Failed to load conversation');
      });
  }

  closeSupportThread() {
    this.setState({ supportSelectedConvo: null, supportMessages: [], replyText: '' });
  }

  handleSendReply() {
    var self = this;
    var convo = this.state.supportSelectedConvo;
    if (!convo || !this.state.replyText.trim()) return;
    self.setState({ replySending: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/messages/' + convo._id + '/reply', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: self.state.replyText.trim() }),
    })
      .then(function(data) {
        self.setState(function(prev) {
          return {
            supportMessages: prev.supportMessages.concat([data.message]),
            replyText: '',
            replySending: false,
          };
        });
        self.fetchSupportConversations();
      })
      .catch(function(err) {
        console.log('Failed to send reply:', err);
        self.setState({ replySending: false });
        alert('Failed to send reply: ' + (err.message || 'Unknown error'));
      });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var tab = this.state.tab;

    // Thread slide-over
    if (this.state.selectedConvo) {
      return this.renderThread();
    }

    // Support thread view
    if (tab === 'support' && this.state.supportSelectedConvo) {
      return this.renderSupportThread();
    }

    return (
      <div>
        <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mb-6">Message Moderation</h2>

        {/* Tabs */}
        <div className="tw-flex tw-gap-1 tw-mb-6">
          {[
            { key: 'conversations', label: 'Conversations', icon: 'fa-comments' },
            { key: 'flagged', label: 'Flagged', icon: 'fa-flag' },
            { key: 'support', label: 'Support Inbox', icon: 'fa-headset' },
          ].map(function(t) {
            return (
              <button
                key={t.key}
                onClick={function() { self.setState({ tab: t.key }); }}
                className={'tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-border-0 tw-cursor-pointer tw-transition-colors ' +
                  (tab === t.key
                    ? 'tw-text-[#1a1a1a] dark:tw-text-white'
                    : 'tw-text-[#999] tw-bg-transparent hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#222]')
                }
                style={tab === t.key ? { backgroundColor: 'rgba(212,168,67,0.1)' } : {}}
              >
                <i className={'fa ' + t.icon + ' tw-mr-1.5'} style={tab === t.key ? { color: '#D4A843' } : {}} />
                {t.label}
              </button>
            );
          })}
        </div>

        {tab === 'conversations' ? this.renderConversations() : tab === 'flagged' ? this.renderFlagged() : this.renderSupport()}
      </div>
    );
  }

  renderConversations() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var conversations = this.state.conversations;

    return (
      <div>
        {/* Filters */}
        <div className="tw-flex tw-flex-wrap tw-gap-3 tw-mb-4">
          <div className="tw-relative tw-flex-1" style={{ minWidth: 200, maxWidth: 320 }}>
            <i className="fa fa-search tw-absolute tw-left-3 tw-text-[#999]" style={{ top: '50%', transform: 'translateY(-50%)' }} />
            <input
              type="text"
              value={this.state.search}
              onChange={function(e) {
                var val = e.target.value;
                self.setState({ search: val });
                clearTimeout(self.searchTimeout);
                self.searchTimeout = setTimeout(function() {
                  self.setState({ convoPage: 1 }, function() { self.fetchConversations(1); });
                }, 400);
              }}
              placeholder="Search by username..."
              className="tw-w-full tw-pl-9 tw-pr-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white"
            />
          </div>
          <select
            value={this.state.statusFilter}
            onChange={function(e) { self.setState({ statusFilter: e.target.value, convoPage: 1 }, function() { self.fetchConversations(1); }); }}
            className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white"
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="flagged">Flagged</option>
            <option value="admin_closed">Closed</option>
          </select>
        </div>

        {this.state.convoLoading ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <i className="fa fa-circle-o-notch fa-spin tw-text-3xl" style={{ color: '#D4A843' }} />
          </div>
        ) : conversations.length === 0 ? (
          <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <i className="fa fa-comments-o tw-text-4xl tw-text-[#ccc] tw-mb-3" style={{ display: 'block' }} />
            <p className="tw-text-sm tw-text-[#999] tw-m-0">No conversations found</p>
          </div>
        ) : (
          <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            {conversations.map(function(convo) {
              var participants = (convo.participants || []).map(function(p) { return p.userName || 'Unknown'; }).join(', ');
              var statusColor = convo.status === 'active' ? '#10B981' : convo.status === 'flagged' ? '#EF4444' : '#6B7280';
              var timeStr = convo.lastMessageAt ? new Date(convo.lastMessageAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';

              return (
                <div key={convo._id} className="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#fafafa] dark:hover:tw-bg-[#1e1e1e]">
                  <div className="tw-flex-1 tw-min-w-0 tw-cursor-pointer" onClick={function() { self.openThread(convo._id); }}>
                    <div className="tw-flex tw-items-center tw-gap-2">
                      <span className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-truncate">{participants}</span>
                      <span className="tw-inline-flex tw-items-center tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: statusColor }}>
                        {convo.status}
                      </span>
                    </div>
                    <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-0.5 tw-truncate">{convo.lastMessage || 'No messages'}</p>
                    <p className="tw-text-[10px] tw-text-[#bbb] tw-m-0 tw-mt-0.5">{timeStr}</p>
                  </div>
                  <div className="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0">
                    <button
                      onClick={function() { self.openThread(convo._id); }}
                      className="tw-px-2.5 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5]"
                    >
                      <i className="fa fa-eye" /> View
                    </button>
                    {convo.status === 'active' && (
                      <button
                        onClick={function() { self.handleCloseConversation(convo._id); }}
                        className="tw-px-2.5 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-border-0 tw-text-white tw-cursor-pointer hover:tw-opacity-90"
                        style={{ backgroundColor: '#6B7280' }}
                      >
                        <i className="fa fa-times" /> Close
                      </button>
                    )}
                  </div>
                </div>
              );
            })}

            {/* Pagination */}
            {this.state.convoPages > 1 && (
              <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3">
                <span className="tw-text-xs tw-text-[#999]">Page {this.state.convoPage} of {this.state.convoPages}</span>
                <div className="tw-flex tw-gap-2">
                  <button
                    disabled={this.state.convoPage <= 1}
                    onClick={function() { var p = self.state.convoPage - 1; self.setState({ convoPage: p }, function() { self.fetchConversations(p); }); }}
                    className="tw-px-2.5 tw-py-1 tw-rounded tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-cursor-pointer disabled:tw-opacity-50"
                  >Prev</button>
                  <button
                    disabled={this.state.convoPage >= this.state.convoPages}
                    onClick={function() { var p = self.state.convoPage + 1; self.setState({ convoPage: p }, function() { self.fetchConversations(p); }); }}
                    className="tw-px-2.5 tw-py-1 tw-rounded tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-cursor-pointer disabled:tw-opacity-50"
                  >Next</button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderFlagged() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var messages = this.state.flaggedMessages;

    if (this.state.flaggedLoading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
          <i className="fa fa-circle-o-notch fa-spin tw-text-3xl" style={{ color: '#D4A843' }} />
        </div>
      );
    }

    if (messages.length === 0) {
      return (
        <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          <div className="tw-w-16 tw-h-16 tw-rounded-full tw-mx-auto tw-mb-4 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#ECFDF5' }}>
            <i className="fa fa-check tw-text-2xl" style={{ color: '#10B981' }} />
          </div>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">No Flagged Messages</h3>
          <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-1">All messages are clean</p>
        </div>
      );
    }

    return (
      <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
        {messages.map(function(msg) {
          return (
            <div key={msg._id} className="tw-px-4 tw-py-3 tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222]">
              <div className="tw-flex tw-items-start tw-gap-3">
                <div className="tw-w-8 tw-h-8 tw-rounded-full tw-bg-[#f0f0f0] dark:tw-bg-[#333] tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-flex-shrink-0">
                  {msg.sender && msg.sender.profilePic ? (
                    <img src={msg.sender.profilePic} alt="" className="tw-w-full tw-h-full tw-object-cover" />
                  ) : (
                    <i className="fa fa-user tw-text-xs tw-text-[#999]" />
                  )}
                </div>
                <div className="tw-flex-1 tw-min-w-0">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    <button
                      onClick={function() { if (msg.sender) self.props.onOpenUserModal(msg.sender._id); }}
                      className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-sm tw-font-semibold tw-cursor-pointer hover:tw-underline"
                      style={{ color: '#D4A843' }}
                    >
                      {msg.sender ? msg.sender.userName : 'Unknown'}
                    </button>
                    <span className="tw-inline-flex tw-items-center tw-gap-1 tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: '#EF4444' }}>
                      <i className="fa fa-flag" style={{ fontSize: 8 }} /> Flagged
                    </span>
                  </div>
                  <p className="tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mt-1" style={{ wordBreak: 'break-word' }}>{msg.text}</p>
                  <p className="tw-text-[10px] tw-text-[#999] tw-m-0 tw-mt-1">
                    Flagged {msg.flaggedAt ? new Date(msg.flaggedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : ''}
                  </p>
                </div>
                <button
                  onClick={function() { if (msg.conversation) self.openThread(typeof msg.conversation === 'string' ? msg.conversation : msg.conversation._id); }}
                  className="tw-px-2.5 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5] tw-flex-shrink-0"
                >
                  View Thread
                </button>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderThread() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var convo = this.state.selectedConvo;
    var messages = this.state.threadMessages;

    if (this.state.threadLoading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
          <i className="fa fa-circle-o-notch fa-spin tw-text-3xl" style={{ color: '#D4A843' }} />
        </div>
      );
    }

    var participants = convo && convo.participants ? convo.participants.map(function(p) { return p.userName || 'Unknown'; }).join(' & ') : 'Conversation';

    return (
      <div>
        {/* Header */}
        <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
          <button
            onClick={this.closeThread}
            className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-[#999] tw-cursor-pointer hover:tw-text-[#666]"
          >
            <i className="fa fa-arrow-left tw-text-lg" />
          </button>
          <div>
            <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">{participants}</h2>
            <p className="tw-text-xs tw-text-[#999] tw-m-0">
              Status: {convo ? convo.status : 'unknown'}
              {convo && convo.status === 'active' && (
                <button
                  onClick={function() { self.handleCloseConversation(convo._id); }}
                  className="tw-ml-3 tw-text-xs tw-px-2 tw-py-0.5 tw-rounded tw-border-0 tw-text-white tw-cursor-pointer hover:tw-opacity-90"
                  style={{ backgroundColor: '#6B7280' }}
                >
                  Close
                </button>
              )}
            </p>
          </div>
        </div>

        {/* Participant chips */}
        {convo && convo.participants && (
          <div className="tw-flex tw-gap-2 tw-mb-4">
            {convo.participants.map(function(p) {
              return (
                <button
                  key={p._id}
                  onClick={function() { self.props.onOpenUserModal(p._id); }}
                  className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-full tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-cursor-pointer hover:tw-bg-[#f5f5f5]"
                >
                  <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#f0f0f0] dark:tw-bg-[#333] tw-overflow-hidden">
                    {p.profilePic ? (
                      <img src={p.profilePic} alt="" className="tw-w-full tw-h-full tw-object-cover" />
                    ) : (
                      <i className="fa fa-user" style={{ fontSize: 8, padding: 4, color: '#999' }} />
                    )}
                  </div>
                  <span className="tw-font-medium" style={{ color: '#D4A843' }}>{p.userName}</span>
                </button>
              );
            })}
          </div>
        )}

        {/* Messages */}
        <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          {messages.length === 0 ? (
            <div className="tw-p-8 tw-text-center">
              <p className="tw-text-sm tw-text-[#999] tw-m-0">No messages in this conversation</p>
            </div>
          ) : (
            <div className="tw-divide-y tw-divide-[#f0f0f0] dark:tw-divide-[#222]">
              {messages.map(function(msg) {
                return (
                  <div key={msg._id} className={'tw-px-4 tw-py-3 ' + (msg.flagged ? 'tw-bg-red-50 dark:tw-bg-[#2a1a1a]' : '') + (msg.deletedAt ? ' tw-opacity-50' : '')}>
                    <div className="tw-flex tw-items-start tw-gap-3">
                      <div className="tw-w-8 tw-h-8 tw-rounded-full tw-bg-[#f0f0f0] dark:tw-bg-[#333] tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-flex-shrink-0">
                        {msg.sender && msg.sender.profilePic ? (
                          <img src={msg.sender.profilePic} alt="" className="tw-w-full tw-h-full tw-object-cover" />
                        ) : (
                          <i className="fa fa-user tw-text-xs tw-text-[#999]" />
                        )}
                      </div>
                      <div className="tw-flex-1 tw-min-w-0">
                        <div className="tw-flex tw-items-center tw-gap-2">
                          <button
                            onClick={function() { if (msg.sender) self.props.onOpenUserModal(msg.sender._id); }}
                            className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-sm tw-font-semibold tw-cursor-pointer hover:tw-underline"
                            style={{ color: '#D4A843' }}
                          >
                            {msg.sender ? msg.sender.userName : 'Unknown'}
                          </button>
                          <span className="tw-text-[10px] tw-text-[#999]">
                            {new Date(msg.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
                          </span>
                          {msg.flagged && (
                            <span className="tw-inline-flex tw-items-center tw-gap-0.5 tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: '#EF4444' }}>
                              <i className="fa fa-flag" style={{ fontSize: 8 }} /> Flagged
                            </span>
                          )}
                          {msg.deletedAt && (
                            <span className="tw-text-[10px] tw-text-[#999]">(deleted)</span>
                          )}
                        </div>
                        <p className="tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mt-1" style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{msg.text}</p>
                      </div>
                      {!msg.flagged && !msg.deletedAt && (
                        <button
                          onClick={function() { self.handleFlagMessage(msg._id); }}
                          className="tw-px-2 tw-py-1 tw-rounded tw-text-[10px] tw-font-medium tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#EF4444] tw-cursor-pointer hover:tw-bg-red-50 tw-flex-shrink-0"
                          title="Flag message"
                        >
                          <i className="fa fa-flag" />
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
  renderSupport() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var conversations = this.state.supportConversations;

    return (
      <div>
        {/* Active / Closed filter + Search */}
        <div className="tw-flex tw-flex-wrap tw-gap-3 tw-mb-4 tw-items-center">
          <div className="tw-flex tw-rounded-lg tw-overflow-hidden tw-border tw-border-[#d0d0d0] dark:tw-border-[#555]">
            {[
              { key: 'active', label: 'Active' },
              { key: 'closed', label: 'Closed' },
            ].map(function(f) {
              var isActive = self.state.supportStatusFilter === f.key;
              return (
                <button
                  key={f.key}
                  onClick={function() {
                    self.setState({ supportStatusFilter: f.key, supportPage: 1 }, function() { self.fetchSupportConversations(1); });
                  }}
                  className="tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-border-0 tw-cursor-pointer tw-transition-colors"
                  style={isActive
                    ? { backgroundColor: '#7C3AED', color: '#fff' }
                    : { backgroundColor: isDark ? '#222' : '#fff', color: '#999' }
                  }
                >
                  {f.label}
                </button>
              );
            })}
          </div>
          <div className="tw-relative tw-flex-1" style={{ minWidth: 200, maxWidth: 320 }}>
            <i className="fa fa-search tw-absolute tw-left-3 tw-text-[#999]" style={{ top: '50%', transform: 'translateY(-50%)' }} />
            <input
              type="text"
              value={this.state.supportSearch}
              onChange={function(e) {
                var val = e.target.value;
                self.setState({ supportSearch: val });
                clearTimeout(self.supportSearchTimeout);
                self.supportSearchTimeout = setTimeout(function() {
                  self.setState({ supportPage: 1 }, function() { self.fetchSupportConversations(1); });
                }, 400);
              }}
              placeholder="Search by username..."
              className="tw-w-full tw-pl-9 tw-pr-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white"
            />
          </div>
        </div>

        {this.state.supportLoading ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <i className="fa fa-circle-o-notch fa-spin tw-text-3xl" style={{ color: '#D4A843' }} />
          </div>
        ) : conversations.length === 0 ? (
          <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <i className={'fa tw-text-4xl tw-text-[#ccc] tw-mb-3 ' + (this.state.supportStatusFilter === 'closed' ? 'fa-check-circle' : 'fa-headset')} style={{ display: 'block' }} />
            <p className="tw-text-sm tw-text-[#999] tw-m-0">{this.state.supportStatusFilter === 'closed' ? 'No closed conversations' : 'No active support conversations'}</p>
          </div>
        ) : (
          <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            {conversations.map(function(convo) {
              var nonAdminParticipants = (convo.participants || []).filter(function(p) { return p.role !== 'admin'; });
              var userNames = nonAdminParticipants.map(function(p) { return p.userName || 'Unknown'; }).join(', ') || 'Unknown User';
              var timeStr = convo.lastMessageAt ? new Date(convo.lastMessageAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';
              var statusColor = convo.status === 'active' ? '#10B981' : convo.status === 'flagged' ? '#EF4444' : '#6B7280';

              return (
                <div
                  key={convo._id}
                  className="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#fafafa] dark:hover:tw-bg-[#1e1e1e] tw-cursor-pointer"
                  onClick={function() { self.openSupportThread(convo._id); }}
                >
                  {/* Avatar */}
                  <div className="tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: '#7C3AED' }}>
                    <i className="fa fa-shield tw-text-white" style={{ fontSize: 16 }} />
                  </div>

                  <div className="tw-flex-1 tw-min-w-0">
                    <div className="tw-flex tw-items-center tw-gap-2">
                      <span className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-truncate">{userNames}</span>
                      <span className="tw-inline-flex tw-items-center tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: '#7C3AED' }}>
                        Admin
                      </span>
                      <span className="tw-inline-flex tw-items-center tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: statusColor }}>
                        {convo.status}
                      </span>
                      {convo.needsReply && (
                        <span className="tw-inline-flex tw-items-center tw-gap-1 tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: '#F59E0B' }}>
                          <i className="fa fa-reply" style={{ fontSize: 8 }} /> Needs Reply
                        </span>
                      )}
                    </div>
                    <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-0.5 tw-truncate">{convo.lastMessage || 'No messages'}</p>
                    <p className="tw-text-[10px] tw-text-[#bbb] tw-m-0 tw-mt-0.5">{timeStr}</p>
                  </div>

                  <i className="fa fa-chevron-right tw-text-[#ccc] tw-flex-shrink-0" />
                </div>
              );
            })}

            {/* Pagination */}
            {this.state.supportPages > 1 && (
              <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3">
                <span className="tw-text-xs tw-text-[#999]">Page {this.state.supportPage} of {this.state.supportPages} ({this.state.supportTotal} total)</span>
                <div className="tw-flex tw-gap-2">
                  <button
                    disabled={this.state.supportPage <= 1}
                    onClick={function(e) { e.stopPropagation(); var p = self.state.supportPage - 1; self.setState({ supportPage: p }, function() { self.fetchSupportConversations(p); }); }}
                    className="tw-px-2.5 tw-py-1 tw-rounded tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-cursor-pointer disabled:tw-opacity-50"
                  >Prev</button>
                  <button
                    disabled={this.state.supportPage >= this.state.supportPages}
                    onClick={function(e) { e.stopPropagation(); var p = self.state.supportPage + 1; self.setState({ supportPage: p }, function() { self.fetchSupportConversations(p); }); }}
                    className="tw-px-2.5 tw-py-1 tw-rounded tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-cursor-pointer disabled:tw-opacity-50"
                  >Next</button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderSupportThread() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var convo = this.state.supportSelectedConvo;
    var messages = this.state.supportMessages;

    if (this.state.supportThreadLoading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
          <i className="fa fa-circle-o-notch fa-spin tw-text-3xl" style={{ color: '#D4A843' }} />
        </div>
      );
    }

    var nonAdminParticipants = convo && convo.participants ? convo.participants.filter(function(p) { return p.role !== 'admin'; }) : [];
    var userNames = nonAdminParticipants.map(function(p) { return p.userName || 'Unknown'; }).join(' & ') || 'Unknown User';

    return (
      <div>
        {/* Header */}
        <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
          <button
            onClick={this.closeSupportThread}
            className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-[#999] tw-cursor-pointer hover:tw-text-[#666]"
          >
            <i className="fa fa-arrow-left tw-text-lg" />
          </button>
          <div className="tw-flex-1">
            <div className="tw-flex tw-items-center tw-gap-2">
              <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">{userNames}</h2>
              <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: '#7C3AED' }}>
                <i className="fa fa-shield tw-mr-1" style={{ fontSize: 8 }} /> Admin Conversation
              </span>
            </div>
            <p className="tw-text-xs tw-text-[#999] tw-m-0">
              Status: {convo ? convo.status : 'unknown'}
              {convo && convo.status === 'active' && (
                <button
                  onClick={function() { self.handleCloseConversation(convo._id); }}
                  className="tw-ml-3 tw-text-xs tw-px-2 tw-py-0.5 tw-rounded tw-border-0 tw-text-white tw-cursor-pointer hover:tw-opacity-90"
                  style={{ backgroundColor: '#6B7280' }}
                >
                  Close
                </button>
              )}
            </p>
          </div>
        </div>

        {/* Participant chips */}
        {convo && convo.participants && (
          <div className="tw-flex tw-flex-wrap tw-gap-2 tw-mb-4">
            {convo.participants.map(function(p) {
              var isAdmin = p.role === 'admin';
              return (
                <button
                  key={p._id}
                  onClick={function() { self.props.onOpenUserModal(p._id); }}
                  className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-full tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-cursor-pointer hover:tw-bg-[#f5f5f5]"
                  style={isAdmin ? { borderColor: '#7C3AED' } : {}}
                >
                  <div className="tw-w-5 tw-h-5 tw-rounded-full tw-overflow-hidden tw-flex tw-items-center tw-justify-center" style={isAdmin ? { backgroundColor: '#7C3AED' } : { backgroundColor: isDark ? '#333' : '#f0f0f0' }}>
                    {isAdmin ? (
                      <i className="fa fa-shield tw-text-white" style={{ fontSize: 8 }} />
                    ) : p.profilePic ? (
                      <img src={p.profilePic} alt="" className="tw-w-full tw-h-full tw-object-cover" />
                    ) : (
                      <i className="fa fa-user" style={{ fontSize: 8, color: '#999' }} />
                    )}
                  </div>
                  <span className="tw-font-medium" style={{ color: isAdmin ? '#7C3AED' : '#D4A843' }}>{p.userName}</span>
                  {isAdmin && <span className="tw-text-[10px] tw-text-[#7C3AED]">(Admin)</span>}
                </button>
              );
            })}
          </div>
        )}

        {/* Messages */}
        <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          {messages.length === 0 ? (
            <div className="tw-p-8 tw-text-center">
              <p className="tw-text-sm tw-text-[#999] tw-m-0">No messages in this conversation</p>
            </div>
          ) : (
            <div className="tw-divide-y tw-divide-[#f0f0f0] dark:tw-divide-[#222]">
              {messages.map(function(msg) {
                var isAdminMsg = msg.sender && msg.sender.role === 'admin';
                return (
                  <div key={msg._id} className={'tw-px-4 tw-py-3 ' + (msg.flagged ? 'tw-bg-red-50 dark:tw-bg-[#2a1a1a]' : '') + (msg.deletedAt ? ' tw-opacity-50' : '')} style={isAdminMsg ? { backgroundColor: isDark ? 'rgba(124,58,237,0.08)' : 'rgba(124,58,237,0.04)' } : {}}>
                    <div className="tw-flex tw-items-start tw-gap-3">
                      <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-flex-shrink-0" style={isAdminMsg ? { backgroundColor: '#7C3AED' } : { backgroundColor: isDark ? '#333' : '#f0f0f0' }}>
                        {isAdminMsg ? (
                          <i className="fa fa-shield tw-text-white" style={{ fontSize: 12 }} />
                        ) : msg.sender && msg.sender.profilePic ? (
                          <img src={msg.sender.profilePic} alt="" className="tw-w-full tw-h-full tw-object-cover" />
                        ) : (
                          <i className="fa fa-user tw-text-xs tw-text-[#999]" />
                        )}
                      </div>
                      <div className="tw-flex-1 tw-min-w-0">
                        <div className="tw-flex tw-items-center tw-gap-2">
                          <button
                            onClick={function() { if (msg.sender) self.props.onOpenUserModal(msg.sender._id); }}
                            className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-sm tw-font-semibold tw-cursor-pointer hover:tw-underline"
                            style={{ color: isAdminMsg ? '#7C3AED' : '#D4A843' }}
                          >
                            {msg.sender ? msg.sender.userName : 'Unknown'}
                          </button>
                          {isAdminMsg && (
                            <span className="tw-inline-flex tw-items-center tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: '#7C3AED' }}>
                              Admin
                            </span>
                          )}
                          <span className="tw-text-[10px] tw-text-[#999]">
                            {new Date(msg.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
                          </span>
                          {msg.flagged && (
                            <span className="tw-inline-flex tw-items-center tw-gap-0.5 tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-text-white" style={{ backgroundColor: '#EF4444' }}>
                              <i className="fa fa-flag" style={{ fontSize: 8 }} /> Flagged
                            </span>
                          )}
                        </div>
                        <p className="tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mt-1" style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{msg.text}</p>
                      </div>
                      {/* No flag button in support inbox — admins have full control here */}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Reply composer */}
        {convo && convo.status !== 'admin_closed' && (
          <div className="tw-mt-4 tw-rounded-xl tw-p-4" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <textarea
              value={this.state.replyText}
              onChange={function(e) { self.setState({ replyText: e.target.value }); }}
              placeholder="Type your reply..."
              rows={3}
              maxLength={2000}
              className="tw-w-full tw-p-3 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-resize-none"
              style={{ outline: 'none' }}
              disabled={this.state.replySending}
            />
            <div className="tw-flex tw-items-center tw-justify-between tw-mt-2">
              <span className="tw-text-[10px] tw-text-[#999]">{this.state.replyText.length} / 2000</span>
              <button
                onClick={this.handleSendReply}
                disabled={this.state.replySending || !this.state.replyText.trim()}
                className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-border-0 tw-text-white tw-cursor-pointer hover:tw-opacity-90 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                style={{ backgroundColor: '#7C3AED' }}
              >
                {this.state.replySending ? (
                  <span><i className="fa fa-circle-o-notch fa-spin tw-mr-1.5" /> Sending...</span>
                ) : (
                  <span><i className="fa fa-paper-plane tw-mr-1.5" /> Send Reply</span>
                )}
              </button>
            </div>
          </div>
        )}

        {convo && convo.status === 'admin_closed' && (
          <div className="tw-mt-4 tw-rounded-xl tw-p-4 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#f9fafb', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <i className="fa fa-times-circle tw-text-[#999] tw-mr-1.5" />
            <span className="tw-text-sm tw-text-[#999]">This conversation has been closed</span>
          </div>
        )}
      </div>
    );
  }
}

export default AdminMessages;
